import {
    Activity,
    Archive,
    ArrowLeft,
    ArrowRight,
    ArrowUp,
    ArrowUpRight,
    Award,
    BadgeCheck,
    Ban,
    Bell,
    Bold,
    BookOpen,
    BookOpenText,
    Building2,
    Calendar,
    Camera,
    CalendarCheck,
    CalendarPlus,
    ChartBar,
    Check,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronsUpDown,
    ChevronUp,
    Circle,
    CircleAlert,
    CircleCheck,
    CircleDollarSign,
    CirclePause,
    CirclePlay,
    CircleSmall,
    CircleX,
    Clipboard,
    Clock,
    Code,
    CodeXml,
    Contact,
    Copy,
    Download,
    CreditCard,
    DollarSign,
    Ellipsis,
    EllipsisVertical,
    Eye,
    EyeOff,
    File,
    FileText,
    Folder,
    FileCheck,
    FolderCode,
    FolderOpen,
    FolderPlus,
    GraduationCap,
    Handshake,
    Headphones,
    Heart,
    HelpCircle,
    History,
    Lock,
    House,
    Image,
    Inbox,
    Info,
    Italic,
    Languages,
    Layers,
    Layers2,
    LayoutDashboard,
    Lightbulb,
    LightbulbOff,
    List,
    ListOrdered,
    ListFilterPlus,
    Link,
    Kanban,
    LoaderCircle,
    LogIn,
    LogOut,
    type LucideIconData,
    Mail,
    MapPin,
    Medal,
    Menu,
    MessageCircle,
    MessageSquare,
    Minus,
    Mic,
    Monitor,
    Moon,
    MoveRight,
    Palette,
    PanelLeft,
    Pencil,
    Phone,
    PhoneCall,
    Plus,
    Popcorn,
    Puzzle,
    ReceiptText,
    RefreshCw,
    Rocket,
    Search,
    Save,
    SendHorizontal,
    Share2,
    Settings,
    Shield,
    Smartphone,
    Sparkles,
    Square,
    SquareKanban,
    SquareLibrary,
    Star,
    Sun,
    SunMoon,
    Table,
    Tablet,
    Tag,
    Terminal,
    TextAlignCenter,
    TextAlignEnd,
    TextAlignStart,
    Trash2,
    TriangleAlert,
    Upload,
    Trophy,
    TrendingDown,
    TrendingUp,
    Truck,
    Underline,
    User,
    UserPlus,
    Users,
    Wallet,
    Wand,
    X,
    Zap,
} from 'lucide-angular'

const DarkMode: LucideIconData = [
    ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0' }],
    ['path', { d: 'M12 3l0 18' }],
    ['path', { d: 'M12 9l4.65 -4.65' }],
    ['path', { d: 'M12 14.3l7.37 -7.37' }],
    ['path', { d: 'M12 19.6l8.85 -8.85' }],
]

export const ZARD_ICONS = {
    house: House,
    settings: Settings,
    user: User,
    search: Search,
    'send-horizontal': SendHorizontal,
    bell: Bell,
    mail: Mail,
    calendar: Calendar,
    'log-out': LogOut,
    'panel-left': PanelLeft,
    bold: Bold,
    inbox: Inbox,
    italic: Italic,
    underline: Underline,
    'text-align-center': TextAlignCenter,
    'text-align-end': TextAlignEnd,
    'text-align-start': TextAlignStart,
    check: Check,
    x: X,
    info: Info,
    'triangle-alert': TriangleAlert,
    circle: Circle,
    'circle-alert': CircleAlert,
    'circle-check': CircleCheck,
    'circle-x': CircleX,
    'circle-dollar-sign': CircleDollarSign,
    'circle-small': CircleSmall,
    ban: Ban,
    'chevron-down': ChevronDown,
    'chevron-up': ChevronUp,
    'chevron-left': ChevronLeft,
    'chevron-right': ChevronRight,
    'chevrons-up-down': ChevronsUpDown,
    'move-right': MoveRight,
    'arrow-right': ArrowRight,
    'arrow-up': ArrowUp,
    'arrow-up-right': ArrowUpRight,
    folder: Folder,
    'folder-open': FolderOpen,
    'folder-plus': FolderPlus,
    file: File,
    'file-text': FileText,
    'layout-dashboard': LayoutDashboard,
    'loader-circle': LoaderCircle,
    save: Save,
    copy: Copy,
    eye: Eye,
    'eye-off': EyeOff,
    visibility: Eye,
    ellipsis: Ellipsis,
    terminal: Terminal,
    clipboard: Clipboard,
    moon: Moon,

    sun: Sun,
    lightbulb: Lightbulb,
    'lightbulb-off': LightbulbOff,
    palette: Palette,
    sparkles: Sparkles,
    wand: Wand,
    heart: Heart,
    star: Star,
    zap: Zap,
    popcorn: Popcorn,
    shield: Shield,
    puzzle: Puzzle,
    layers: Layers,
    'layers-2': Layers2,
    kanban: Kanban,
    'square-kanban': SquareKanban,
    'square-library': SquareLibrary,
    code: Code,
    'code-xml': CodeXml,
    'book-open': BookOpen,
    'book-open-text': BookOpenText,
    users: Users,
    monitor: Monitor,
    smartphone: Smartphone,
    tablet: Tablet,
    'badge-check': BadgeCheck,
    'folder-code': FolderCode,
    plus: Plus,
    minus: Minus,
    'arrow-left': ArrowLeft,
    archive: Archive,
    clock: Clock,
    'calendar-plus': CalendarPlus,
    'list-filter-plus': ListFilterPlus,
    'list-ordered': ListOrdered,
    'message-square': MessageSquare,
    trash: Trash2,
    'trash-2': Trash2,
    edit: Pencil,
    pencil: Pencil,
    image: Image,
    upload: Upload,
    tag: Tag,
    'sun-moon': SunMoon,
    'dark-mode': DarkMode,
    square: Square,
    'dollar-sign': DollarSign,
    'user-plus': UserPlus,
    'credit-card': CreditCard,
    activity: Activity,
    menu: Menu,
    'help-circle': HelpCircle,
    contact: Contact,
    'log-in': LogIn,
    'message-circle': MessageCircle,
    'refresh-cw': RefreshCw,
    phone: Phone,
    'phone-call': PhoneCall,
    'map-pin': MapPin,
    'graduation-cap': GraduationCap,
    trophy: Trophy,
    medal: Medal,
    award: Award,
    truck: Truck,
    'receipt-text': ReceiptText,
    wallet: Wallet,
    building: Building2,
    'building-2': Building2,
    link: Link,
} as const satisfies Record<string, LucideIconData>

/** Map Material-style icon names to Lucide icons for SvgIcon fallback */
export const SVG_TO_LUCIDE_FALLBACK: Record<string, LucideIconData> = {
    add: Plus,
    bold: Bold,
    italic: Italic,
    underline: Underline,
    list: List,
    'list-ordered': ListOrdered,
    'message-square': MessageSquare,
    check: Check,
    close: X,
    delete: Trash2,
    'trash-2': Trash2,
    'file-text': FileText,
    file_text: FileText,
    eye: Eye,
    visibility: Eye,
    trash: Trash2,
    help_outline: HelpCircle,
    contact_support: Contact,
    person_add: UserPlus,
    login: LogIn,
    schedule: Clock,
    menu: Menu,
    info: Info,
    help: HelpCircle,
    edit_note: FileText,
    edit: Pencil,
    archive: Archive,
    plus: Plus,
    x: X,
    refresh: RefreshCw,
    swap_horiz: MoveRight,
    arrow_back: ArrowLeft,
    arrow_left: ArrowLeft,
    'arrow-left': ArrowLeft,
    'eye-off': EyeOff,
    expand_more: ChevronDown,
    expand_less: ChevronUp,
    chevron_left: ChevronLeft,
    chevron_right: ChevronRight,
    'arrow-right': ArrowRight,
    arrow_forward: ArrowRight,
    keyboard_arrow_down: ChevronDown,
    keyboard_arrow_up: ChevronUp,
    notifications: Bell,
    account_circle: User,
    insights: Activity,
    dashboard: LayoutDashboard,
    people: Users,
    view_list: List,
    approval: BadgeCheck,
    support_agent: Headphones,
    translate: Languages,
    grid_view: LayoutDashboard,
    table_view: Table,
    person: User,
    pencil: Pencil,
    zap: Zap,
    save: Save,
    sync: RefreshCw,
    phone: Smartphone,
    smartphone: Smartphone,
    email: Mail,
    link: Link,
    settings: Settings,
    logout: LogOut,
    upload: ArrowUp,
    cloud_upload: ArrowUp,
    file_upload: ArrowUp,
    school: GraduationCap,
    'graduation-cap': GraduationCap,
    groups: Users,
    monitor: Monitor,
    emoji_events: Trophy,
    'emoji-events': Trophy,
    payments: Wallet,
    credit_card: CreditCard,
    business: Building2,
    local_shipping: Truck,
    receipt: ReceiptText,
    place: MapPin,
    source: FileText,
    call: PhoneCall,
    contacts: Contact,
    copy: Copy,
    content_copy: Copy,
    highlight_off: CircleX,
    play_circle_filled: CirclePlay,
    pause_circle_filled: CirclePause,
    arrow_drop_down: ChevronDown,
    event: Calendar,
    forum: MessageCircle,
    more_horiz: Ellipsis,
    user_plus: UserPlus,
    message_square: MessageSquare,
    mail: Mail,
    work: Link,
    filter_list: ListFilterPlus,
    chat: MessageCircle,
    move_right: MoveRight,
    clock: Clock,
    check_circle: CircleCheck,
    remove: Minus,
    error_outline: CircleAlert,
    warning: TriangleAlert,
    inventory_2: Archive,
    info_outline: Info,
    supervised_user_circle: Users,
    // File type icons (Feedback File, attachments, etc.)
    picture_as_pdf: FileText,
    description: FileText,
    table_chart: Table,
    'table-chart': Table,
    image: Image,
    slideshow: FileText,
    insert_drive_file: File,
    send_horizontal: SendHorizontal,
    calendar_today: Calendar,
    building: Building2,
    'building-2': Building2,
    /** Lead lost / blocked — CRM status modal header (replaces cancel/close next to title) */
    ban: Ban,
    /** Sidebar / nav — distinct icons per item */
    home: House,
    rocket: Rocket,
    inbox: Inbox,
    /** CRM pipeline: personal board vs team board */
    kanban: Kanban,
    'square-kanban': SquareKanban,
    clients: Building2,
    folder_open: FolderOpen,
    orders: Wallet,
    autorenew: RefreshCw,
    'trending-down': TrendingDown,
    trending_down: TrendingDown,
    'trending-up': TrendingUp,
    trending_up: TrendingUp,
    assessment: ChartBar,
    handshake: Handshake,
    'bar-chart': ChartBar,
    'circle-dollar-sign': CircleDollarSign,
    shield: Shield,
    tag: Tag,
    map_pin: MapPin,
    'map-pin': MapPin,
    wand: Wand,
    sparkles: Sparkles,
    auto_awesome: Sparkles,
    /** Field Visits — past-visits entry point, time-of-day bands, "add to calendar" */
    history: History,
    calendar_check: CalendarCheck,
    sun: Sun,
    moon: Moon,
    // Field Visit: capture, the voice recorder and the visit-detail chrome.
    mic: Mic,
    stop: Square,
    photo_camera: Camera,
    lock: Lock,
    more_vert: EllipsisVertical,
    download: Download,
    file_check: FileCheck,
    search: Search,
    share: Share2,
    arrow_upward: ArrowUp,
}

export declare type ZardIcon = keyof typeof ZARD_ICONS | LucideIconData
